import React from 'react';
import PropTypes from 'prop-types';
import { useFeatureFlags } from '@lms/react-configuration/context/feature-flags';

const FeatureToggler = ({ children, featureName }) => {
  const { features } = useFeatureFlags();

  return (
    <>
      {features?.[featureName] && (
        <>
          { children }
        </>
      )}
    </>
  );
};

FeatureToggler.propTypes = {
  children: PropTypes.node.isRequired,
  featureName: PropTypes.node.isRequired,
};

export default FeatureToggler;
